var React = require('react');

function IconAddFolderSolid (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M927 227.5H593.9l-59.7-98.9H100.3c-17.8 0-32.7 14.8-32.7 33.1v700.7c0 18.6 14.7 33.1 32.8 33.1h827c18.1 0 32.8-14.7 32.8-32.9V260.3c0-17.9-14.9-32.8-33.2-32.8zM750.9 574.7c0 5.5-4.5 10-10 10H546.6V780c0 5.5-4.5 10-10 10h-45.3c-5.5 0-10-4.5-10-10V584.7H286c-5.5 0-10-4.5-10-10v-45.3c0-5.5 4.5-10 10-10h195.3V325.1c0-5.5 4.5-10 10-10h45.3c5.5 0 10 4.5 10 10v194.3h194.3c5.5 0 10 4.5 10 10v45.3z"}));
}

IconAddFolderSolid.displayName = "IconAddFolderSolid";

IconAddFolderSolid.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconAddFolderSolid;

IconAddFolderSolid.default = IconAddFolderSolid;
